import "../../../style/staticPages.css"


export const static507 = (
    <div className="staticPageText ">
        <div className="partialContainer ">
            <h2 className="">
                    LEHGU - inhaltliche Einführung
            </h2>

            <div className="lehguParagraph ">
                <p>Am <em>Freiburger Institut für Musikermedizin</em> (FIM) – Albert-Ludwigs-Universität und Universitätsklinikum Freiburg – 
                wurde ein digitales Fortbildungsangebot zur stimmlichen und mentalen Gesundheit für Lehrkräfte im Beruf entwickelt, welches in Kooperation mit dem 
                <em>Zentrum für Schulqualität und Lehrerbildung Baden-Württemberg</em> (ZSL) im Schuljahr 2021/2022 in Baden-Württemberg erstmalig angeboten wurde. 
                Diese staatlich anerkannte Fortbildung mit dem Titel <em>LEHGU – Schult Stimme und Stimmung </em>richtet sich an Lehrkräfte aller Schularten und Fächerkombinationen.
                </p>
            </div>

            <img src="	https://lehgu.de/prof_cms/fileadmin/lehgu/images/logo.svg" alt="logo.svg  " title="" className="img-fluid " id="2390-0" loading="auto"></img>

            <div className="lehguParagraph">
                <p>„LEHGU“ leitet sich von „<strong>Leh</strong>rer*innen<strong>g</strong>es<strong>u</strong>ndheit“ ab. 
                Die Förderung der Gesundheit von Lehrkräften ist auch das Hauptanliegen der Fortbildung. Der Untertitel „Schult Stimme und Stimmung“ verdeutlicht 
                einerseits den Bezug zur Lehr- und Unterrichtspraxis und spiegelt andererseits die enge Wechselwirkung von Stimmgesundheit und psychischem Wohlbefinden wieder. 
                Die Fortbildung verfolgt das Anliegen, die Themen wissenschaftlich aufzubereiten und sie mit Aspekten der Schulpraxis im Lehrkraftberuf zu verbinden.</p>
                <p>Die Inhalte der Fortbildung umfassen neben allgemeinen Aspekten zu <em>Gesundheit und Gesundheitsrisiken im Beruf</em> auch psychoedukative Inhalte zur 
                Gesundheitsförderung wie beispielsweise den Zusammenhang zwischen <em>Stimme und Psyche</em> oder den <em>Umgang mit Stress</em>. Außerdem werden <em>Grundlagen der 
                Stimmphysiologie </em>sowie Strategien zur <em>Gesunderhaltung der Stimme</em> vermittelt und es wird auf <em>pädagogische und kommunikative Aspekte der Stimme im 
                Lehrkraftberuf</em> eingegangen.</p><p>&nbsp;</p><p>Das e-Learning-Modul des Fortbildungsprogramms <em>LEHGU</em> besteht aus 
                <strong>acht Lerneinheiten</strong>, die Sie unter „Inhalte“ finden.
                </p>
            </div>

            <img src="https://lehgu.de/prof_cms/fileadmin/user_upload/UEbersicht_Inhalte_LEHGU_2_ohne_schwarzen_Rand.png" alt="UEbersicht_Inhalte_LEHGU_2.png" 
                title="" className=" mb-8" id="img-2450-0" loading="auto">
            </img>

            <div className="lehguParagraph ">
                <p>Die Lerneinheiten folgen keiner vorgegebenen Hierarchie, sondern können <strong>interessengeleitet </strong>
                und unabhängig voneinander bearbeitet werden. Zahlreiche Querverweise innerhalb der Lerneinheiten erleichtern die inhaltliche Verknüpfung der einzelnen Themenbereiche. 
                Als zeitlicher Richtwert sollten ungefähr 60-90 Minuten pro Lerneinheit eingeplant werden, wobei diese Zeitangabe je nach Vertiefungswunsch und persönlicher 
                Gestaltung variieren kann.</p><p>Alle Lerneinheiten folgen dem didaktischen Konzept der Direkten Instruktion, wobei die Inhalte kleinschrittig aufgebaut sind. 
                So wird jede Lerneinheit durch <strong>zwei oder&nbsp;</strong><strong>drei Leitfragen</strong> strukturiert und auf diese Weise in mehrere thematische Unterkapitel gegliedert, 
                die jeweils durch eine Einführung und eine Zusammenfassung gerahmt sind.</p><p>Die Inhalte werden unter Verwendung <em>vielfältiger Medien</em> wie Textelementen, 
                Video- und Audioaufnahmen etc. aufbereitet. Zur Visualisierung und Erläuterung der didaktischen Funktion werden in der Gliederung <strong>Icons</strong> verwendet, 
                deren Bedeutungen im Folgenden aufgeführt sind:
                </p>
            </div>
        </div>
        <div className="imageGridContainer509">
            <h2>Icon-Übersicht Inhalte</h2>
            <div className="imageGrid ">
                <div className="imageGridRow ">
                    <div className="imageGridRowItem">
                        <img src="	https://lehgu.de/prof_cms/fileadmin/images/prefix_video.svg" alt="prefix_video.svg  " 
                            title="" className="img-fluid img-rounded img-fullwidth" id="" loading="auto"></img>
                        <div className="imageGridRowItemText ">Video</div>
                    </div>
                    <div className="imageGridRowItem">
                        <img src="	https://lehgu.de/prof_cms/fileadmin/images/prefix_text.svg" alt="prefix_video.svg  " 
                            title="" className="img-fluid img-rounded img-fullwidth" id="" loading="auto"></img>
                        <div className="imageGridRowItemText ">Textelemente</div>
                    </div>
                    <div className="imageGridRowItem">
                        <img src="https://lehgu.de/prof_cms/fileadmin/images/prefix_audio.svg" alt="prefix_video.svg  " 
                            title="" className="img-fluid img-rounded img-fullwidth" id="" loading="auto"></img>
                        <div className="imageGridRowItemText ">Audioformate</div>
                    </div>
                </div>
                <div className="imageGridRow ">
                    <div className="imageGridRowItem">
                        <img src="https://lehgu.de/prof_cms/fileadmin/images/prefix_uebung_audio.svg" alt="prefix_video.svg  " 
                            title="" className="img-fluid img-rounded img-fullwidth" id="" loading="auto"></img>
                        <div className="imageGridRowItemText ">Audioübung</div>
                    </div>
                    <div className="imageGridRowItem">
                        <img src="https://lehgu.de/prof_cms/fileadmin/images/prefix_uebung_video.svg" alt="prefix_video.svg  " 
                            title="" className="img-fluid img-rounded img-fullwidth" id="" loading="auto"></img>
                        <div className="imageGridRowItemText ">Videoübung</div>
                    </div>
                    <div className="imageGridRowItem">
                        <img src="https://lehgu.de/prof_cms/fileadmin/images/prefix_uebung_text.svg" alt="prefix_video.svg  " 
                            title="" className="img-fluid img-rounded img-fullwidth" id="" loading="auto"></img>
                        <div className="imageGridRowItemText ">Textübung</div>
                    </div>
                </div>
                <div className="imageGridRow ">
                    <div className="imageGridRowItem">
                        <img src="https://lehgu.de/prof_cms/fileadmin/images/prefix_erklaerfilm.svg" alt="prefix_video.svg  " 
                            title="" className="img-fluid img-rounded img-fullwidth" id="" loading="auto"></img>
                        <div className="imageGridRowItemText ">Erklärfilm</div>
                    </div>
                    <div className="imageGridRowItem">
                        <img src="https://lehgu.de/prof_cms/fileadmin/images/prefix_reflexion.svg" alt="prefix_video.svg  " 
                            title="" className="img-fluid img-rounded img-fullwidth" id="" loading="auto"></img>
                        <div className="imageGridRowItemText ">Reflexionsaufgabe</div>
                    </div>
                    <div className="imageGridRowItem">
                        <img src="https://lehgu.de/prof_cms/fileadmin/images/logo-lehgu-plus-50x50b.svg" alt="prefix_video.svg  " 
                            title="" className="img-fluid img-rounded img-fullwidth" id="" loading="auto"></img>
                        <div className="imageGridRowItemText ">Exkurs</div>
                    </div>
                </div>
                <div className="simgleImageRow ">
                    <div className="imageGridRowItem">
                        <img src="https://lehgu.de/prof_cms/fileadmin/user_upload/Icon_Quiz_blanko.svg" alt="prefix_video.svg  " 
                            title="" className="img-fluid img-rounded img-fullwidth" id="" loading="auto"></img>
                        <div className="imageGridRowItemText ">Quiz</div>
                    </div>
                </div>
            </div>

        </div>


    </div>
)